import React from "react";

// molecules
import { DashboardMobile, DashboardWeb } from "@molecules/index";
import { SidebarMenuProvider } from "@hooks/menuItensContext";

// Hooks
import { useWindowDimensions } from "@hooks/useWindowDimensions";

import * as Styled from "./styles";
import Office from "../Office";

const Dashboard: React.FC = () => {
  const { width } = useWindowDimensions();

  return (
    <Office>{width > 1280 ? <DashboardWeb /> : <SidebarMenuProvider><DashboardMobile /> </SidebarMenuProvider>}</Office>
  );
};

export default Dashboard;
